import { createStyles, Theme } from '@material-ui/core';
import { AlertTitle } from '@material-ui/lab';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Space } from '@/components';
import { storeRemoveNotification } from '@/model/global/actions';
import { makeSelectIsMobileView, makeSelectNotifications } from '@/model/global/selectors';
import { GlobalNotificationWithMessage, GlobalNotificationWithMessageId } from '@/model/global/types';

const Alert: React.FC<AlertProps> = (props: AlertProps) => <MuiAlert elevation={6} variant="filled" {...props} />;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toastBox: {
      position: 'absolute',
      zIndex: 1000,
      paddingTop: theme.spacing(2.5),
      padding: theme.spacing(2),
      width: theme.MainContainer.width,
    },
    toastBoxMobile: {
      position: 'absolute',
      zIndex: 1000,
      paddingTop: theme.spacing(0.5),
      padding: theme.spacing(),
      width: '100%',
      maxWidth: theme.MainContainer.width,
    },
  }),
);

const selectNotifications = makeSelectNotifications();
const selectIsMobile = makeSelectIsMobileView();

const Notifications: React.FC = () => {
  const classes = useStyles();
  const notifications = useSelector(selectNotifications);
  const dispatch = useDispatch();
  const isMobile = useSelector(selectIsMobile);

  return notifications.length > 0 ? (
    <Space className={isMobile ? classes.toastBoxMobile : classes.toastBox} direction="vertical">
      {notifications.map((notification) => (
        <Alert
          data-test={`notification-message-${(notification as GlobalNotificationWithMessageId).messageId
            || (notification as GlobalNotificationWithMessage).message}`}
          key={notification.id}
          severity={notification.severity}
          onClose={(): void => {
            storeRemoveNotification({ id: notification.id })(dispatch);
          }}
        >
          {notification.titleId && (
            <AlertTitle>
              <FormattedMessage id={notification.titleId} />
            </AlertTitle>
          )}
          {(notification as GlobalNotificationWithMessage).message || (
            <FormattedMessage id={(notification as GlobalNotificationWithMessageId).messageId} />
          )}
        </Alert>
      ))}
    </Space>
  ) : (
    <></>
  );
};

export default Notifications;
